exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._30nLB5BugFVSzXOoLBhdQr{padding-left:1.42857rem;padding-right:1.42857rem;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}@media only screen and (min-width:640px){._30nLB5BugFVSzXOoLBhdQr{padding-left:2.14286rem;padding-right:2.14286rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"Student": "_30nLB5BugFVSzXOoLBhdQr"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Student/style.postcss
// module id = 2120
// module chunks = 0